import { render, staticRenderFns } from "./EntityHeader.vue?vue&type=template&id=26015614&scoped=true"
import script from "./EntityHeader.vue?vue&type=script&lang=js"
export * from "./EntityHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26015614",
  null
  
)

export default component.exports